import React from 'react';
import PropTypes from 'prop-types';

import { getValue } from '_utils';
import { getACLicensePoolSelectionOptions } from '_utils/licensePools';
import { getACLicenseCode, getACLicensePoolLabel, getACLicenseUserLabel } from '_utils/activationCodes';

import {
  Form,
  Button
} from 'semantic-ui-react';

import AcSourceField from '_forms/source';
import LineItem from '_views/lineItem';

const InstitutionTransferACForm = ({
  data,
  license,
  institution,
  onChange,
  onSubmit
}) => {

  const onFieldChange = (_, field) => onChange(field.name, getValue(field));
  const poolOptions = getACLicensePoolSelectionOptions(institution.license_pools)
    .filter(entry => entry.value !== license.license_pool_id);

  return (
    <Form size='tiny' onSubmit={ onSubmit } >
      <Form.Group>
        <Form.Field>
          <LineItem label="AC" text={ getACLicenseCode(license) } />
          <LineItem label="Current Pool" text={ getACLicensePoolLabel(license) } />
          <LineItem label="Current User" text={ getACLicenseUserLabel(license) } />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <AcSourceField
          width={12}
          name='license_pool_id'
          placeholder='Select a License Pool'
          value={ data.license_pool_id }
          options={ poolOptions }
          onChange={ onFieldChange }
        />
      </Form.Group>
      <Button.Group>
        <Button positive type="submit">Transfer License</Button>
      </Button.Group>
    </Form>
  );
};

InstitutionTransferACForm.propTypes = {
  data: PropTypes.shape({
    license_pool_id: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  license: PropTypes.object.isRequired,
  institution: PropTypes.object.isRequired
}

export default InstitutionTransferACForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/acTransferInstitution.js